import React, { Component } from 'react';
import { Amount } from '../shared';

class CostPrice extends Component {
  render() {
    const { item, contact } = this.props;

    if (contact.credShow) {
        return (
          <div className="form-group">
            <label>Inkoopprijs:</label>
            <span className="form-control auto-height">
                <Amount amount={item.unitPx} />
            </span>
          </div>
        );
    } else {
        return (
            <div className="form-group">
            <label>Gemiddelde kostprijs:</label>
            <span className="form-control auto-height">
                <Amount amount={item.costPx} />
            </span>
            </div>
        );
    }
  }
}

export default CostPrice;



// WEBPACK FOOTER //
// ./src/history/CostPrice.js